import React from "react";
import { Route, Switch } from "react-router-dom";
import Login from "../Screens/Login";
import Verify from "../Screens/Verify";
import Splash from "../Screens/Splash";
import Main from "../Screens/Main";
import Payment from "../Screens/Payment/Payment";
import PaymentHistory from "../Screens/PaymentHistory/PaymentHistory";
import UsageManagment from "../Screens/UsageManagment/UsageManagment";
import WaitingForPay from "../Screens/WaitingForPay/WaitingForPay";
import BillInfoPage from "../Screens/BillInfo/index";
import Profile from "../Screens/Profile";
import FAQPage from "../Screens/FAQ";
import AboutUs from "../Screens/AboutUs";
import ChartPage from "../Screens/ChartPage";
import Rotate from "../Screens/Rotate";
import AddToHome from "../Screens/A2HS";
import SMSPay from "../Screens/SMSPay";
import ContactUs from "../Screens/ContactUs/ContactUs";
import PayWithBillId from "../Screens/PayWithBillId";
import Tickets from "../Screens/Tickets";
import NewTicket from "../Screens/Tickets/NewTicket";
import Messages from "../Screens/Messages";
import MessagesSingle from "../Screens/Messages/MessagesSingle";
import TicketSingle from "../Screens/Tickets/TicketSingle";
import SingleBillHistory from "../Screens/PaymentHistory/SingleBillHistory";
// import Route from "./Route";
export default function Routes() {
  return (
    <Switch>
      <Route path={"/"} exact component={Splash} />
      <Route path={"/login"} component={Login} />
      <Route path={"/rotate"} component={Rotate} />
      <Route path={"/verify"} component={Verify} isPrivate />
      <Route path={"/Main"} component={Main} isPrivate />
      <Route path={"/faq"} component={FAQPage} isPrivate />
      <Route path={"/aboutus"} component={AboutUs} />
      <Route path={"/contactus"} component={ContactUs} />
      <Route path={"/usage"} component={UsageManagment} isPrivate />
      <Route path={"/history"} component={PaymentHistory} isPrivate />
      <Route path={"/waiting"} component={WaitingForPay} isPrivate />
      <Route path={"/billInfo"} component={BillInfoPage} isPrivate />
      <Route path={"/profile"} component={Profile} isPrivate />
      <Route path={"/chart"} component={ChartPage} isPrivate />
      <Route path={"/addToHome"} component={AddToHome} isPrivate />
      <Route path={"/SMSPay"} component={SMSPay} />
      <Route path={"/MessagesSingle"} component={MessagesSingle} />
      <Route path={"/TicketSingle"} component={TicketSingle} />
      <Route path={"/SingleBillHistory"} component={SingleBillHistory} />
      <Route path={"/PayWithBillId"} component={PayWithBillId} />
      <Route path={"/Tickets"} component={Tickets} />
      <Route path={"/NewTicket"} component={NewTicket} />
      <Route path={"/Messages"} component={Messages} />
      <Route path={`/Payment/:topicId`} component={Payment} />
      <Route path={`/Payment/rotate`} component={Rotate} />
    </Switch>
  );
}
